export {ErrorModel, layerLoad, layerClose}

// 接口状态码处理
function ErrorModel (data) {
  var _this = this
  _this.layerClose()
  if (data.error_no === '2002' && sessionStorage.getItem('auth_token') && sessionStorage.getItem('auth_token') !== 'undefined') {
    _this.$layer.open({
      title: false,
      content: data.error_info,
      btnAlign: 'c', // 按钮居中
      offset: ['30%', '40%'],
      btn: _this.$t('layuiModelconfirm')
    })
  } else if (data.error_no === '2002') {
    _this.$layer.open({
      title: false,
      content: data.error_info,
      btnAlign: 'c', // 按钮居中
      offset: ['30%', '40%'],
      btn: _this.$t('layuiModelconfirm'),
      yes: function (index) {
        var params = {
          path: _this.$route.path,
          query: _this.$route.query
        }
        sessionStorage.setItem('lasturl', JSON.stringify(params))
        _this.$layer.close(index)
        try {
          // 此处主要处理 在综合风险的负面新闻弹窗中进行操作出现的失效情况
          if (location.href !== parent.location.href) {
            // 上层非嵌入+本地iframe
            var frameIndex = parent.layer.getFrameIndex(window.name)
            parent.layer.close(frameIndex)
            parent.location.href = '/#/login'
          } else {
            // 上层非嵌入+本地无iframe
            location.href = '/#/login'
          }
        } catch (error) {
          // 上层嵌入式非同源会抛异常
          location.href = '/#/login'
        }
      }
    })
  // } else if (data.error_no === 'updata') {
  //   _this.$layer.open({
  //     title: false,
  //     content: data.error_info,
  //     btnAlign: 'c', // 按钮居中
  //     offset: ['30%', '40%'],
  //     btn: _this.$t('layuiModelconfirm'),
  //     yes: function (index) {
  //       _this.$layer.close(index)
  //       location.reload()
  //     }
  //   })
  } else {
    _this.$layer.open({
      title: false,
      content: data.error_info,
      btnAlign: 'c', // 按钮居中
      offset: ['30%', '40%'],
      btn: _this.$t('layuiModelconfirm'),
      end: function () {
      }
    })
  }
}

// 加载层
function layerLoad () {
  window.index = window.layer.load(2, {
    shade: [0.5, '#ccc'],
    offset: ['50%', '50%']
  })
}

// 关闭加载层
function layerClose () {
  window.layer.close(window.index)
}



// WEBPACK FOOTER //
// ./src/assets/js/common/layerModel.js